'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SearchIcon = require('../SearchIcon');

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewSpotSearchInput = function NewSpotSearchInput(_ref) {
  var inputProps = _ref.inputProps;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-new-navigation-bar__search__wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-new-navigation-bar__search__icon__container' },
      _react2.default.createElement(_SearchIcon2.default, null)
    ),
    _react2.default.createElement(
      'div',
      { className: 'quiver-new-navigation-bar__search__input__container' },
      _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
        className: 'quiver-new-navigation-bar__search__wrapper__input',
        type: 'text'
      }))
    )
  );
};

NewSpotSearchInput.propTypes = {
  inputProps: _propTypes2.default.object.isRequired
};

exports.default = NewSpotSearchInput;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearchInput/NewSpotSearchInput.js
// module id = 306
// module chunks = 0